module.exports = __webpack_public_path__ + "b4a259ac4974f5ad51f42404b099b093.svg";